import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

export const homeContract = c.router({
  getHome: {
    method: 'GET',
    path: '/',
    responses: {
      200: z.object({
        requestTime: z.string(),
      }),
    },
  },
  triggerReducer: {
    method: 'GET',
    path: '/test-reducer/:lrn',
    pathParams: z.object({ lrn: z.string() }),
    responses: {
      200: z.object({ sourceSystems: z.array(z.string()) }),
    },
  },
  syncCustomsLrn: {
    method: 'GET',
    path: '/sync-customs/:lrn',
    pathParams: z.object({ lrn: z.string() }),
    responses: {
      200: z.object({ sourceSystem: z.string() }),
    },
  },
});
